import React, { useState } from "react";
import { useAssignContactsToAssetMutation } from "../store/slices/mapsSlice";
import ContactsList from "../Contacts/ContactsList";
import { toCamel } from "../Maps/helpers";
import { useGetEventContactsViaAssetsQuery } from "../store/slices/settingsSlice";
import { Button, Offcanvas } from "react-bootstrap";
import MyPagination from "../Common/MyPagination";

export default function EventsAssetContactsSlider({ item }: { item: any }) {
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <Button
        variant=""
        onClick={handleShow}
        className="fw-bold text-white badge bg-secondary"
      >
        Contacts
      </Button>
      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ width: "800px" }}
        size="xl"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Contacts of Assets Related to Event</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <EventAssetContacts selectedAsset={item} />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

function EventAssetContacts({ selectedAsset }: { selectedAsset: any }) {
  const [pagination, setPagination] = useState({ page: 0, perPage: 12 });
  const { data: contacts } = useGetEventContactsViaAssetsQuery(
    selectedAsset?.Uuid || "",
    {
      skip: !selectedAsset?.Uuid,
    }
  );

  return (
    <div className="">
      {contacts?.contacts && (
        <>
          <ContactsList
            contacts={((contacts?.contacts as any) || []).map((i: any) =>
              toCamel(i)
            )}
            refreshList={undefined}
            notDraggable={undefined}
            fullView={true}
            isModal={undefined}
            showContactFields={undefined}
            onSelectContacts={undefined}
            contactButton={undefined}
            allContactsButton={undefined}
          />
          <MyPagination
            total={contacts.total}
            onPaginate={(page, perPage) => setPagination({ page, perPage })}
          />
        </>
      )}
    </div>
  );
}
